import { cx } from '@emotion/css';
import type { FC } from 'react';

import { MotifComponent, useMotifStyles } from '../../motif';
import { Anchor } from '../Primitives';
import { topicStylesCss } from './Topic.styles';
import type { TopicProps } from './types';

export const Topic: FC<TopicProps> = props => {
  useMotifStyles(MotifComponent.TOPIC);
  const { displayText, url } = props;

  if (!displayText) {
    return null;
  }

  if (!url) {
    return (
      <span className={cx(MotifComponent.TOPIC, topicStylesCss)} data-testid={MotifComponent.TOPIC}>
        {displayText}
      </span>
    );
  }

  return (
    <Anchor
      className={cx(MotifComponent.TOPIC, topicStylesCss)}
      href={url}
      data-testid={MotifComponent.TOPIC}
    >
      {displayText}
    </Anchor>
  );
};
